module.exports = __webpack_public_path__ + "img/pethouse59.425f29a9.jpg";